// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__RI7xI","wrapperFull":"Spinner_wrapperFull__KoNJg"};